<template>
  <v-chip :color="label.color" text-color="white" label>
    <v-row align="center" justify="center" class="pl-4">
      {{ label.name }}
      <VSpacer />
      <v-btn icon color="#d4fefefe" @click="deleteLabel()">
        <v-icon small>mdi-close</v-icon>
      </v-btn>
    </v-row>
  </v-chip>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'OrderLabel',
  props: {
    label: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...mapActions({
      deleteOrderLabel: 'order/deleteOrderLabel',
    }),
    deleteLabel() {
      this.$confirm('', {
        title: 'Odebrat štítek?',
        buttonTrueText: 'Ano',
        buttonFalseText: 'Ne',
        icon: '',
        color: 'black',
      }).then((result) => {
        if (result) {
          this.deleteOrderLabel({ id: this.$route.params.orderId, labelId: this.label.id }).finally(
            () => {
              this.$emit('labelDeleted')
            }
          )
        }
      })
    },
  },
}
</script>
